import React, { Component } from "react";
import classnames from "classnames";

import { IBattery } from "@formant/core/model/IBattery";
import { HStack } from "@formant/ui/component/common/HStack";
import cssColors from "@formant/ui/style/colorExports.scss";

import * as styles from "./BatteryIcon.scss";

export interface IBatteryIconProps {
    large?: boolean;
    value: IBattery;
    label?: string;
    className?: string;
}

export class BatteryIcon extends Component<IBatteryIconProps> {
    public render() {
        const { label, value, className, large } = this.props;
        const { percentage, voltage, current, charge } = value;
        const factor =
            percentage && Math.min(Math.max(0, percentage), 100) / 100;

        let fillColor = cssColors.primaryColor;
        if (factor) {
            if (factor < 0.1) {
                fillColor = cssColors.criticalColor;
            } else if (factor < 0.2) {
                fillColor = cssColors.errorColor;
            } else if (factor < 0.3) {
                fillColor = cssColors.warningColor;
            }
        }
        let tooltip = `${percentage.toFixed(2)}% charged`;
        if (voltage !== undefined) {
            tooltip += `, ${voltage.toFixed(2)} volts`;
        }
        if (current !== undefined) {
            tooltip += `, ${current.toFixed(2)} amps`;
        }
        if (charge !== undefined) {
            tooltip += `, ${charge.toFixed(2)} amp hours`;
        }

        const svgWidth = large ? 24 : 17;
        const svgHeight = large ? 20 : 10;

        return (
            <HStack
                className={classnames(
                    styles["battery-icon"],
                    large && styles["large-battery"],
                    className,
                )}
                vAlign="center"
            >
                {label && <div className={styles.label}>{label}</div>}
                <svg
                    width={svgWidth}
                    height={svgHeight}
                    viewBox="0 0 17 10"
                    data-tooltip={tooltip}
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.3838 2.25834L2.71293 2.25834L2.71293 7.53335L12.3838 7.53335L12.3838 2.25834ZM2.71293 0.5C1.74182 0.5 0.95459 1.28723 0.95459 2.25834V7.53335C0.95459 8.50445 1.74182 9.29169 2.71293 9.29169H12.3838C13.3549 9.29169 14.1421 8.50445 14.1421 7.53335V2.25834C14.1421 1.28723 13.3549 0.5 12.3838 0.5H2.71293Z"
                        fill="var(--formant-steel-03)"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.8296 3.5C16.2438 3.5 16.5796 3.83579 16.5796 4.25V5.75C16.5796 6.16421 16.2438 6.5 15.8296 6.5C15.4154 6.5 15.0796 6.16421 15.0796 5.75V4.25C15.0796 3.83579 15.4154 3.5 15.8296 3.5Z"
                        fill="var(--formant-steel-03)"
                    />
                    {factor && (
                        <rect
                            x="3.39209"
                            y="2.80078"
                            width={8.5 * factor}
                            height="4.2"
                            fill={fillColor}
                        />
                    )}
                </svg>
            </HStack>
        );
    }
}
